import { apiKeySelector } from '../auth/selectors';

export const getToken = (state) => apiKeySelector(state);
